import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga'
import { persistStore, persistReducer } from 'redux-persist'
import {routerMiddleware} from 'react-router-redux';
import storage from 'redux-persist/lib/storage'
import rootReducer from './rootReducer';
import rootSaga from '../services/sagas/index';
import {routerHistoryMiddleware} from './navigation/navigationDucks';
import { composeWithDevTools } from 'redux-devtools-extension';
import { dateRevivalTransform } from './persistDateTransform';

//const createLogger = require('redux-logger').createLogger;
const createHistory = require("history").createBrowserHistory;

// Exported so tests can exercise the real rehydrate pipeline (persistConfig.transforms)
// against the exact config the app wires up, instead of a re-implementation (AB#35566).
export const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['loginState'],
  // AB#35566: revives Date fields that JSON.stringify turned into ISO strings on
  // the way into storage - nothing did this before, so every Date-typed field in
  // a persisted slice (e.g. dataEntryState.requestAnalysis) was a string at
  // runtime after a reload despite TypeScript reporting it as Date.
  transforms: [dateRevivalTransform],
}

//const loggerMiddleware = createLogger();
const sagaMiddleware = createSagaMiddleware()
const persistedReducer = persistReducer(persistConfig, rootReducer)
export const history = createHistory();
export const store = configureStore(history);
export const persistor = persistStore(store)

export function configureStore(history: any) {
  const middleware = routerHistoryMiddleware(history);
  const reduxMiddleware = routerMiddleware(history)

  let reduxStore = createStore(
    persistedReducer,
    composeWithDevTools(
      applyMiddleware(
        //loggerMiddleware,
        sagaMiddleware,
        middleware,
        reduxMiddleware
      )
    )
  );
  sagaMiddleware.run(rootSaga)
  return reduxStore;
}
